import { MutationTree } from 'vuex';
import { OriginatorsState } from './types';

export const mutations: MutationTree<OriginatorsState> = {
    setOriginators:(state, data) => {
        state.originators = data
    },
    setOriginatorItem:(state, data) => {
        state.originatorItem = data
    },
};